import { render, staticRenderFns } from "./GbfsDataset.vue?vue&type=template&id=5ec1e934"
import script from "./GbfsDataset.vue?vue&type=script&lang=js"
export * from "./GbfsDataset.vue?vue&type=script&lang=js"
import style0 from "./GbfsDataset.vue?vue&type=style&index=0&id=5ec1e934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports